import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DateHelper} from '../../utils/date-helper';
import {OrderStatus} from "../../model/lib/enums/OrderStatus";
import {Order} from "../../model/lib/interfaces/Order";
import {Shift} from "../../model/lib/interfaces/Shift";
import {BusinessService} from "../../providers/gastroflow-services/business-service/business-service";
import {Product} from "../../model/lib/interfaces/Product";
import {OrderProduct} from "../../model/lib/interfaces/OrderProduct";
import {Subject} from "rxjs";
import {Weekday} from "../../model/lib/interfaces/Weekday";
import {MenuHelper, MenuOption} from "../../utils/menu-helper";
import {ShiftHelper} from "../../utils/shift-helper";

/**
 * Generated class for the DaymenuCardComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "daymenu-card",
  templateUrl: "daymenu-card.html"
})
export class DaymenuCardComponent implements OnInit, OnDestroy {
  @Input() order: Order;
  @Input() shift: Shift;

  @Output() consumeClicked: EventEmitter<void> = new EventEmitter();
  @Output() changeClicked: EventEmitter<void> = new EventEmitter();

  protected starterString?: string;
  protected menuString?: string;
  protected desertString?: string;
  protected menuLines: string[] = [];
  protected businessOrderProducts: OrderProduct[] = [];

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private businessService: BusinessService) {
  }

  ngOnInit(): void {
    this.fetchMenu();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected consumeOrder(): void {
    this.consumeClicked.emit();
  }

  protected changeOrder(): void {
    this.changeClicked.emit();
  }

  protected dateFormatted(): string {
    return DateHelper.LongFormat(new Date(this.order.date));
  }

  protected isDefaultShift(): boolean {
    return ShiftHelper.isDefaultShift(this.shift);
  }

  protected isOrderFinished(): boolean {
    return this.order.status === OrderStatus.FINISHED;
  }

  protected isOrderPending(): boolean {
    if (!this.order || !this.order.status || !this.order.id) return false;

    return this.order.status === OrderStatus.PENDING;
  }

  protected fetchMenu(): void {
    if (!this.shift) return;

    const weekdayNr: number = (new Date(this.order.date).getDay() + 6) % 7 + 1;

    this.businessService
      .fetchShiftById(this.shift.id.toString())
      .take(1)
      .takeUntil(this.destroy$)
      .subscribe((shift: Shift) => {
        this.shift = shift;

        if (!weekdayNr) return;

        this.businessService
          .fetchProductsByShiftAndWeekday(this.shift, {
            dayNr: parseInt(weekdayNr.toString()),
          } as Weekday)
          .take(1)
          .takeUntil(this.destroy$)
          .subscribe((weekdayProducts: Product[]) => {
            const menuOptions: MenuOption[] = MenuHelper.buildMenuOptions(weekdayProducts);
            const orderedOption: MenuOption | undefined = MenuHelper.findOptionForOrder(menuOptions, this.order);

            if (menuOptions.length <= 1) {
              this.businessOrderProducts = menuOptions.length ? menuOptions[0].orderProducts : [];

              if (!this.order.orderProducts || !this.order.orderProducts.length) {
                this.order.orderProducts = this.businessOrderProducts;
              }
            } else {
              this.businessOrderProducts = !!orderedOption ? orderedOption.orderProducts : [];
            }

            const shownOption: MenuOption | undefined = menuOptions.length === 1 ? menuOptions[0] : orderedOption;

            this.menuLines = [];

            if (shownOption) {
              this.starterString = shownOption.starterString;
              this.menuString = shownOption.menuString;
              this.desertString = shownOption.desertString;
            } else {
              this.starterString = '';
              this.menuLines = menuOptions.map((option: MenuOption) => option.label);
              this.menuString = this.menuLines.join(', ');
              this.desertString = '';
            }
          });
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/daymenu-card/daymenu-card.ts